
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import bus from '@/javascript/bus'
import {formatDate} from "@/javascript/formatDate"
import Toast from 'vux/src/components/toast/index.vue'


export default {
components: {
Cpts020,
Toast
},
data() {
return {
minHeight: "",
params: JSON.parse(sessionStorage.getItem('historyData')),
id: bus.userInfo.user.id,
planId: '',
nowData: '',
prompt: false,
failureText: '系统繁忙,请稍后再试...',
param: {},
resultStr: {},
startTime: 0,
endTime: 0
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight;

document.title = this.PAGE_TITLE + '生成行程'

const date = new Date();
if (date < (new Date(this.params.planStartDate.replace(/-/g, "\/")))) {
this.nowData = this.params.planStartDate
} else {
const nextDate = new Date(date.getTime() + 24 * 60 * 60 * 1000); 
let x = nextDate.getFullYear()
let y = nextDate.getMonth() + 1
let z = nextDate.getDate()
const val = x + '-' + (y > 9 ? y : '0' + y) + '-' + (z > 9 ? z : '0' + z)
this.nowData = val
}
},
updated() {
this.getPlan()
},
methods: {
jump: function (newId) {
if (newId) {
this.$router.replace({path: '/travel-profile/' + newId})
}
},
goBack() {
this.$router.replace({path: '/choose-spot'})
},
getPlan: function () {
const that = this

if (!that.params || !that.id) {
return
}
that.param = {
"endCityCode": that.params.endCityCode,
"modeOfTransport": null,
"planDays": parseInt(that.params.planDays),
"planStartDate": that.nowData,
"scenicIds": that.params.scenicIds,
"startCityCode": that.params.endCityCode,
"status": 0,
"tags": that.params.tags,
"templateId": 0,
"transportType": that.params.transportType,
"userId": that.id,
"visitorType": that.params.visitorType,
"deptCode": this.DEPT_CODE.DEPTCODE
}
that.$http.post('/api/wtcp-recommend/public/travelPlan/app/plan?', that.param).then((response) => {
if (response.data.status == 0) {
that.$http.post('/api/wtcp-recommend/public/travelPlan/app/plan?param=', that.param).then((response) => {
if (response.data.status == 0) {

setTimeout(function () {
that.prompt = true
}, 1500);
setTimeout(function () {
that.goBack()
}, 3000);
that.resultStr = response.data
that.submitError()
} else {
that.endTime = new Date()
that.planId = response.data.data.id
setTimeout(function () {
that.jump(that.planId)
}, that.computeTime(that.startTime, that.endTime))
}
})
that.resultStr = response.data
that.submitError()
} else {
that.endTime = new Date()
that.planId = response.data.data.id
setTimeout(function () {
that.jump(that.planId)
}, that.computeTime(that.startTime, that.endTime))
}
})
},
submitError() {
const that = this
const curTime = formatDate(new Date(), 'yyyy/MM/dd hh:mm:ss')

that.$http.get('api/wtcp-recommend/public/logs/save?dateStr=' + curTime + '&paramStr=' + JSON.stringify(that.param) + '&resultStr=' + JSON.stringify(that.resultStr) + '&userId=' + that.id).then((response) => {
})
},
computeTime(startTime, endTime) {
const time = parseInt(endTime.getTime() - startTime.getTime())
if (time > 2000) {
return time
} else {
return 2000
}
}
},
created() {
this.startTime = new Date()
}
};
